import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  breadcrumbs: {
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(2),
  },
  breadcrumbLink: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  breadcrumbCurrent: {
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
}));

export default useStyles;

